import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { ProofBand } from '../components/ProofBand';
import { Services } from '../components/Services';
import { Industries } from '../components/Industries';
import { Safety } from '../components/Safety';
import { About } from '../components/About';
import { ProjectQuestions } from '../components/ProjectQuestions';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
import { HeadMeta } from '../components/HeadMeta';
export function Home() {
  return <div id="top" className="min-h-screen w-full bg-warm" data-id="element-240" data-mp="29gdbgferry8c">
      <HeadMeta data-id="element-241" data-mp="29etu0lhdnh4z" />
      <a href="#services" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[60] focus:rounded-sm focus:bg-safety focus:px-4 focus:py-3 focus:font-display focus:uppercase focus:text-ink" data-id="element-242" data-mp="29ihphq6dudmc">
        Skip to content
      </a>
      <Header data-id="element-243" data-mp="3ov2fajqxxpti" />
      <main data-id="element-244" data-mp="3oyyjr58y77gs">
        <Hero data-id="element-245" data-mp="30wroce8elteh" />
        <ProofBand data-id="element-246" data-mp="30xb8m1lj0tvo" />
        <Services data-id="element-247" data-mp="30vqcw8nh74w8" />
        <Industries data-id="element-248" data-mp="30w9m90z28kyn" />
        <Safety data-id="element-249" data-mp="30uozhxizm6bc" />
        <About data-id="element-250" data-mp="2vxotfmm513k8" />
        <ProjectQuestions data-id="element-251" data-mp="2vx6s4bkmbz5g" />
        <Contact data-id="element-252" data-mp="2vyzzjt322nei" />
      </main>
      <Footer data-id="element-253" data-mp="2vvlugd30c03d" />
    </div>;
}